var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackwardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4165 6.29682L13.4165 13.7039C13.4165 13.9239 13.3412 14.1045 13.1905 14.2456C13.0399 14.3865 12.8641 14.457 12.6632 14.457C12.5991 14.457 12.533 14.4479 12.4646 14.4297C12.3962 14.4117 12.3299 14.3845 12.2659 14.3481L6.43588 10.6366C6.32143 10.5586 6.23567 10.4651 6.17859 10.3562C6.12137 10.2472 6.09275 10.1286 6.09275 10.0004C6.09275 9.87217 6.12137 9.75356 6.17859 9.64453C6.23567 9.53564 6.32143 9.44217 6.43588 9.36411L12.2659 5.65266C12.3299 5.61627 12.3962 5.58905 12.4646 5.57099C12.533 5.5528 12.5991 5.5437 12.6632 5.5437C12.8641 5.5437 13.0399 5.61418 13.1905 5.75516C13.3412 5.89627 13.4165 6.07682 13.4165 6.29682ZM12.1665 7.2087L7.77546 10.0004L12.1665 12.792L12.1665 7.2087Z",
    fill: "#304674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardIcon);
export default __webpack_public_path__ + "static/media/backward-icon.f89ae921b352c9c865dee0fbdbe58e78.svg";
export { ForwardRef as ReactComponent };